/**
 * Labstep
 *
 * @module components/ShareLinkInvitation/Action/Create/Organization
 * @desc An action to create a sharelink invitation for organization
 */

import { ShareLinkInvitationActionCreateOrganizationDisabled } from 'labstep-web/components/ShareLinkInvitation/Action/Create/Organization/Disabled';
import { UserOrganizationActionAddBulkUsers } from 'labstep-web/components/UserOrganization/Action/AddBulkUsers';
import type React from 'react';
import type { IShareLinkInvitationActionCreateOrganizationProps } from './types';

export const ShareLinkInvitationActionCreateOrganization: React.FC<
  IShareLinkInvitationActionCreateOrganizationProps
> = ({ organization }) => {
  if (organization.logged_user_user_organization.type !== 'admin') {
    return null;
  }
  if (organization.noSeatsLeft || organization.is_saml_enabled) {
    return (
      <ShareLinkInvitationActionCreateOrganizationDisabled
        organization={organization}
      />
    );
  }

  return (
    <UserOrganizationActionAddBulkUsers organization={organization} />
  );
};
